module.exports = __webpack_public_path__ + "static/media/vip_level_2.70fa3c9e.png";